module.exports = __webpack_public_path__ + "static/media/message.46061bc4.png";